<template>
<div>
	<div class="title">投保信息</div>
	<Form :model="form" :rules="formRules" :label-width="120" class="mt15" ref="form">
	    <FormItem label="投保公司：">
			<!-- {{form.centerName}} -->
			<Select class="w450" v-model="form.centerName" @on-change="onCompanyChange">
				<Option v-for="item in companyData" :value="item.name" :key="item.id">{{ item.name }}</Option>
			</Select>
		</FormItem>
	    <FormItem label="被保公司：" required prop="companyList">
			<FormItem
                v-for="(item, index) in form.companyList"
                :key="index"
                :prop="'companyList.' + index + '.value'"
                :rules="{required: true, message: '请输入被保公司', trigger: 'blur'}">
				<Input :maxlength="20" class="w450" type="text" v-model="item.value" placeholder="请输入被保公司" :disabled="index==0"></Input>
				<Button v-if="index==0&&form.companyList.length>0&&form.companyList.length<5" type="primary" @click="handleAdd">新增</Button>
				<Button v-if="index>0" @click="handleRemove(index)">删除</Button>
        	</FormItem>
		</FormItem>
	    <FormItem label="联系电话：" prop="phone">
	        <Input class="w450" v-model.trim="form.phone" placeholder="请输入手机号" @on-blur="change" :maxlength="20"></Input>
	    </FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info: Object,
		companyData:{
			type: Array,
			default:[]
		}
	},
	data () {
		return {
			form: {
				centerName: '', // 保持兼容性
				companyList: [
					{
						value:''
					}
				]
			},
			formRules:{
				phone:[{required:true,message:'请填写正确的手机号',trigger:'blur',pattern:this.rules.telOrPhone}],
			}
		}
	},
	methods:{
		onCompanyChange(selectedName) {
			if (selectedName) {
				// 通过名称找到完整的对象
				const selectedItem = this.companyData.find(item => item.name === selectedName);
				if (selectedItem) {
					this.form.centerName = selectedItem.name; // 保持向后兼容
					this.$set(this.form,'centerName',selectedItem.name);
					this.$set(this.info,'centerId',selectedItem.id);
					this.$set(this.info,'centerName',selectedItem.name);
					this.$set(this.info,'centerUserName',selectedItem.userName);
					this.$set(this.info,'phone',selectedItem.phone);
					this.$set(this.form.companyList[0],'value',selectedItem.company);
					console.log('选中的完整数据：', selectedItem);
					// 现在可以访问 selectedItem 的所有属性
				}
			}
		},
		handleAdd () {
			if(this.form.companyList.length>=5){
				this.toast('最多只能添加5个被保公司', 'error');
				return
			}
			this.form.companyList.push({
				value: ''
			});
			console.log(this.form.companyList,'21212')
		},
		handleRemove (index) {
			this.form.companyList.splice(index,1);
		},
		// 草稿箱
		drafts(){
			return new Promise ((resolve,rejct)=>{
				resolve(this.form)
			})
		},
		// 校验
		val () {
			return new Promise ((resolve,rejct)=>{
				this.$refs.form.validate(valid=>{
					resolve(valid?this.form:false)
				})
			})
		},
		// 回传给父组件
		change() {
			this.$emit('on-change',this.form)
		}
	},
	watch:{
		info (v) {
			this.form = v;
			if(v.companyListString){
				this.$nextTick(()=>{
					let list = v.companyListString.split('、');
					let newlist = list.map(item=>{
						return { value: item }
					})
					this.$set(this.form, 'companyList', newlist);
				})
			} else {
				this.form.companyList = [
					{
						value:''
					}
				]
			}
		}
	}
}
</script>
<style scoped lang="less">
	.upload-img-main{
		padding:10px 0;
	}
	.box{
		width: 100%;
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/common/applicant.vue